import { EPLEDGE_REQUEST_DETAILS, EPLEDGE_REQUEST_DETAILS_ERROR, EPLEDGE_REQUEST_DETAILS_HIDE_ERROR, EPLEDGE_REQUEST_DETAILS_START_LOADER, EPLEDGE_REQUEST_DETAILS_STOP_LOADER, } from "../interface/iEpledgeRequestDetails";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const epledgeRequestDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case EPLEDGE_REQUEST_DETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case EPLEDGE_REQUEST_DETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EPLEDGE_REQUEST_DETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EPLEDGE_REQUEST_DETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EPLEDGE_REQUEST_DETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default epledgeRequestDetailsReducer;
